module.exports = __webpack_public_path__ + "img/17-large.1abbcd59.png";